import styled from 'styled-components';
import { Box } from '@mui/material';

export const StepperContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.lg};
  margin-bottom: ${({ theme }) => theme.spacing.lg};

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const StepperSidebar = styled(Box)`
  width: 100%;
  
  @media (min-width: 768px) {
    width: 33%;
  }
  
  @media (min-width: 1024px) {
    width: 25%;
  }
`;

export const StepperContent = styled(Box)`
  width: 100%;
  
  @media (min-width: 768px) {
    width: 66%;
  }
  
  @media (min-width: 1024px) {
    width: 75%;
  }
`;

export const CompletionContainer = styled(Box)`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xxxl} 0;
`;

export const ProgressBarContainer = styled.div`
  margin-bottom: 2.5rem;
`;

export const ProgressBar = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const ProgressSegment = styled.div<{ $active: boolean; $activeColor: string }>`
  flex: 1;
  height: 0.25rem;
  border-radius: 0.125rem;
  background-color: ${({ $active, $activeColor, theme }) => 
    $active ? $activeColor : theme.colors.gray200};
  transition: background-color 0.3s ease;
`;

export const ProgressBarContent = styled.div`
  max-width: 56.25rem;
  margin: 0 auto;
  padding: 2.5rem 0;
`;
